"use strict";

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _colors = _interopRequireDefault(require("~data/colors.json"));

var _helpers = require("~utils/helpers");

var styles = _interopRequireWildcard(require("./styles.module.scss"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/** ============================================================================
 * Slice
 */


var ColorGrid = function ColorGrid(_ref) {
  var id = _ref.id,
      className = _ref.className,
      _ref$data = _ref.data,
      backgroundColor = _ref$data.backgroundColor,
      padded = _ref$data.padded,
      dockedTop = _ref$data.dockedTop,
      dockedBottom = _ref$data.dockedBottom,
      mono = _ref$data.mono,
      _ref$data$cardSize = _ref$data.cardSize,
      cardSize = _ref$data$cardSize === void 0 ? "S" : _ref$data$cardSize;
  return /*#__PURE__*/_react.default.createElement("section", {
    sliceid: id,
    className: [className, styles.container, dockedTop ? styles.dockedTop : "", dockedBottom ? styles.dockedBottom : "", padded ? styles.padded : ""].join(" "),
    style: {
      background: (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.hex) || "white"
    }
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: styles.grid
  }, Object.keys(_colors.default).map(function (colorKey) {
    var color = _colors.default[colorKey];
    var title = color.id,
        swatch = color.swatch,
        isMono = color.mono,
        hex = color.hex,
        display = color.display;

    if (!display || isMono !== mono) {
      return null;
    }

    var rgb = (0, _helpers.hexToRGB)(hex);
    var fontColor = display === "dark" ? "white" : "black";
    var itemClassName = [styles.gridItem, styles["gridItem".concat(cardSize)]].join(" ");
    return /*#__PURE__*/_react.default.createElement("li", {
      key: "link-grid-".concat(title),
      className: itemClassName,
      style: {
        background: hex,
        color: fontColor
      }
    }, /*#__PURE__*/_react.default.createElement("article", {
      className: styles.gridItemContent
    }, /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement("p", {
      className: [styles.gridItemContentType, "caption"].join(" ")
    }, isMono ? "MONO" : "PRIMARY"), /*#__PURE__*/_react.default.createElement("p", {
      className: "b2"
    }, title)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
      className: "b2"
    }, hex), /*#__PURE__*/_react.default.createElement("p", {
      className: "b2"
    }, "R ".concat((rgb === null || rgb === void 0 ? void 0 : rgb.r) || "0", "  G ").concat((rgb === null || rgb === void 0 ? void 0 : rgb.g) || "0", "  B ").concat((rgb === null || rgb === void 0 ? void 0 : rgb.g) || "0")), /*#__PURE__*/_react.default.createElement("p", {
      className: "b2"
    }, swatch))));
  })));
};

var _default = ColorGrid;
exports.default = _default;